export default __webpack_public_path__ + "static/media/maracadance.8d3aca83.mp3";